// extracted by mini-css-extract-plugin
export var footer = "_n9-0";
export var inherit = "_n9-1";
export var input = "_n9-2";
export var modalContent = "_n9-3";
export var quillEditor = "_n9-4";
export var subtitle = "_n9-5";